module.exports = __webpack_public_path__ + "img/t2y-new-logo.8181688c.png";